import img from '../../componets/Events/imgsEvents/event.jpg'
import img1 from '../../assets/info/boyero.jpg'
import img2 from '../../assets/info/criterios.jpg'
import img3 from '../../assets/info/estandar.jpg'


export const infoCard = [
{
    title: "Expo",
    path:"/exhibitions",
    descripcion: "Echa un vistazo a las exposiciones pasadas y si quieres participar con tu compañero estas invitado!",
    img: img
},
{
    title: "Sobre los boyeros de berna",
    path:"https://blog.mascotaysalud.com/razas-perros/grandes/boyero-de-berna/",
    descripcion: "Sabias que los Boyeros de Berna son conocidos por su amor por el agua y pueden disfrutar nadando en lagos y ríos. También han sido utilizados como perros de rescate en situaciones de emergencia debido a su fuerza y resistencia.",
    img: img1
},
{
    title: "Criterios de selección a la hora de adquirir un ejemplar",
    path:"/criterios",
    descripcion: "En este apartado encontraras informacion sobre: compatibilidad con tu estilo de vida, tamaño y espacio, compatibilidad con otros animales y niños, salud y temperamento, responsabilidad y presupuesto",
    img: img2
},{
    title: "Acceso al estándar de la raza",
    path:"https://www.fci.be/Nomenclature/Standards/045g02-es.pdf",
    descripcion: "Desde aqui te enviaremos a un pdf en el cual puedes nutrirte de todo el estandar de la raza!",
    img: img3
}
]